module.exports = __webpack_public_path__ + "static/media/wedding-cake-alt.82d3a1c3.svg";